import { TrackingProviderTypeEnum } from '../enums/tracking-provider-type.enum';

export interface ITrackingProvider {
    id: number;
    type: TrackingProviderTypeEnum;
    name: string;
    description?: string;
    isActive?: boolean;
}
